<template>
  <v-list-item-content>
    <v-list-item-title>
      <icone-status-contato :item="contato" />
      {{ contato.nome }}
      <v-chip
        x-small
        class="ml-2"
        v-for="(tipo, j) in contato.tipos"
        :key="`contato-tipo-${j}`"
      >{{ strTipo(tipo) }}</v-chip>
    </v-list-item-title>
    <v-list-item-subtitle>
      <v-row>
        <v-col v-if="principal(contato.telefones)">
          <v-icon>mdi-phone-outline</v-icon>
          {{ maskTelefone(principal(contato.telefones).numero) }}
          <v-icon
            small
            class="ml-1"
            v-if="principal(contato.telefones).celular"
          >mdi-cellphone-android</v-icon>
          <v-icon small class="ml-1" v-if="principal(contato.telefones).whatsapp">mdi-whatsapp</v-icon>
          <v-icon small class="ml-1" v-if="principal(contato.telefones).telegram">mdi-telegram</v-icon>
        </v-col>
        <v-col v-if="principal(contato.emails)">
          <v-icon>mdi-email-outline</v-icon>
          {{ principal(contato.emails).email }}
        </v-col>
      </v-row>
    </v-list-item-subtitle>
  </v-list-item-content>
</template>

<script>
import { build } from "../../lib/masks";
import IconeStatusContato from "./IconeStatusContato";
export default {
  components: { IconeStatusContato },
  props: ["contato"],
  methods: {
    strTipo(tipo) {
      return this.$store.getters["contato/strTipo"](tipo);
    },
    maskTelefone(val) {
      return build.phone(val);
    },
    principal(lista) {
      return this.$store.getters["contato/principal"](lista);
    },
  },
};
</script>